import { IBlockDevicePayload } from '@/types/payload';
import { formatQuery } from '@/utils';

import http from './http';
import serviceHelper from './serviceHelper';

export const getDeviceList = async (query?: Record<string, unknown>) => {
  const queryString = query ? formatQuery(query) : '';
  return serviceHelper(
    http.get(`/admin/device${queryString ? `?${queryString}` : ''}`),
    false
  );
};

export const getDeviceDetails = async (id: string) => {
  return serviceHelper(http.get(`/admin/device/${id}`), false);
};

export const deleteDeviceApi = async (payload: { id: string }) => {
  return serviceHelper(http.delete('/admin/device', { data: payload }), true);
};

export const blockDeviceApi = async (payload: IBlockDevicePayload) => {
  return serviceHelper(http.patch('/admin/device/block', payload), true);
};

export const getDeviceModelDropdown = async () => {
  return serviceHelper(http.get('/admin/device/device-model-dropdown'), false);
};
